var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalculator = function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm1 3h10v3H7zm0 7a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm4 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm4 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm-8 3a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm4 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm4 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm-8 3a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm4 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0zm4 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0z"
  })));
};
export default SvgCalculator;